import { Loading } from '@appd/uik';

interface ComponentLoadingProps {
  name?: string;
}

export default function ComponentLoading({ name }: ComponentLoadingProps) {
  return <Loading.Bar thin />;
}
